var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostPackagesDatatable',{attrs:{"post-indexes":_vm.postIndexes,"post-packages":_vm.postPackages,"loading":_vm.loading,"total":_vm.total,"allow-new-button":true,"allow-new-group-button":true},on:{"update":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }